<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <croptype-form></croptype-form>
      </div>
    </div>
  </div>
</template>

<script>
import CroptypeForm from "@/views/croptype/components/Form.vue";

export default {
  name: "add-croptype",
  components: {
    CroptypeForm,
  }
};
</script>